import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "fl" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "fs14 fw600 mt6",
  style: {"margin-left":"55px"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "fs14 fw600 mt6",
  style: {"margin-left":"55px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = {
  key: 2,
  class: "fs14 fw600 mt6",
  style: {"margin-left":"55px"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.appo && _ctx.room)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: "posFi pinkBg pointer RestrictCalVisibleButton",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goAvailableScheduleView && _ctx.goAvailableScheduleView(...args))),
        onMouseoverOnce: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mouseover(`調整カレンダーを作成`, `${_ctx.rm.tutorial_phase}`)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/icons/calendar_white.png`),
            style: {"width":"33px","height":"33px","margin-top":"6px","margin-left":"14px"}
          }, null, 8, _hoisted_2)
        ]),
        (_ctx.room.is_owner && !_ctx.appo.required_owner_participation)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
              _createTextVNode(" 不参加カレンダー "),
              _hoisted_4,
              _createTextVNode("を更新 ")
            ]))
          : (_ctx.pdm.didShare())
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                _createTextVNode(" 調整カレンダー "),
                _hoisted_6,
                _createTextVNode("を更新 ")
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_7, [
                _createTextVNode(" 調整カレンダー "),
                _hoisted_8,
                _createTextVNode("を作成 ")
              ]))
      ], 32))
    : _createCommentVNode("", true)
}